/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { SheetId } from "../../commons/types/SheetId";
export const AiRuleCreationJobConfig = core.serialization.object({
    label: core.serialization.string().optional(),
    prompt: core.serialization.string(),
    sheetId: SheetId,
    fieldKey: core.serialization.string(),
    index: core.serialization.number().optional(),
});
